__turbopack_context__.v({
  "bigImg": "styles-module-scss-module__sQZfNG__bigImg",
  "biggerGradient": "styles-module-scss-module__sQZfNG__biggerGradient",
  "card": "styles-module-scss-module__sQZfNG__card",
  "certificationFees": "styles-module-scss-module__sQZfNG__certificationFees",
  "certificationName": "styles-module-scss-module__sQZfNG__certificationName",
  "desc": "styles-module-scss-module__sQZfNG__desc",
  "fees": "styles-module-scss-module__sQZfNG__fees",
  "img": "styles-module-scss-module__sQZfNG__img",
  "inCollaborationWith": "styles-module-scss-module__sQZfNG__inCollaborationWith",
  "intersectionDiv": "styles-module-scss-module__sQZfNG__intersectionDiv",
  "name": "styles-module-scss-module__sQZfNG__name",
  "nameContainer": "styles-module-scss-module__sQZfNG__nameContainer",
  "programType": "styles-module-scss-module__sQZfNG__programType",
  "smallCard": "styles-module-scss-module__sQZfNG__smallCard",
  "smallStrip": "styles-module-scss-module__sQZfNG__smallStrip",
  "strikeThrough": "styles-module-scss-module__sQZfNG__strikeThrough",
  "strip": "styles-module-scss-module__sQZfNG__strip",
  "textContainer": "styles-module-scss-module__sQZfNG__textContainer",
  "yearContainer": "styles-module-scss-module__sQZfNG__yearContainer",
});
